/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 * See the LICENSE file for the full text.
 */

/**
 * The words an event travels with.
 *
 * Android shares "<title> — <url>", which is a label rather than an
 * invitation. This is the invitation, and it is the same for every event.
 *
 * WHY IT DOES NOT NAME THE SPORT, which is the first thing anybody reading
 * this will want to change. It did, briefly. The sentence took the event's
 * activities and said "if Running is something you're into" — but the public
 * payload carries only `activity_type_id` for an activity, a bare number, and
 * no joined type row to read a word out of. (See the event public view's
 * related_config: the `categories` block lists `activity_type_id` among its
 * fields and nothing else about the type. It is the same reason the event page
 * itself never prints what an activity IS.) What reached the sentence instead
 * was the organiser's label for the category, so a real share went out reading
 * "If 10K or 21.1K RUN is something you're into".
 *
 * So the clause is deliberately about the interest rather than the sport. It
 * is true of every event in the product, needs nothing the payload does not
 * already carry, and cannot go wrong in somebody's chat.
 *
 * If the type ever does arrive — an `activity_type` up-join added to that
 * related config — naming the sport becomes possible again, and this is the
 * one place the wording would change.
 */

/**
 * The invitation, as one string.
 *
 * Written out whole rather than assembled from parts: this is copy, and
 * somebody changing the wording should see all of it at once.
 */
export const SHARE_MESSAGE = [
  'Hey! This caught my attention, and I thought you might enjoy it! 👀',
  '',
  "If fitness or sports are something you're into (or have been wanting to "
    + 'try), this could be a perfect opportunity to get involved, challenge '
    + 'yourself and take things up a notch.',
  '',
  'Have a look! You never know where one small step might take you. 🔥',
].join('\n');

/**
 * The share message for an event.
 *
 * Takes no argument today and still exists as a function on purpose: it is
 * what the template calls, so the day the copy varies by event again, nothing
 * upstream of here has to change.
 */
export function buildShareMessage() {
  return SHARE_MESSAGE;
}

export default buildShareMessage;
